import {isWeb} from '@/src/shared/utils/functions'

export const getRouteParam = (
  name: string,
  params: Record<any, any>,
  searchParams: Record<any, any>,
) => {
  return isWeb() ? params[name] : searchParams[name]
}
